import cn from 'classnames';
import React from 'react';

export interface Props {
  testId?: string;
  smCols?: 1 | 2;
  lgCols?: 2 | 3;
}

const Grid: React.FC<Props> = ({
  testId,
  children,
  smCols = 2,
  lgCols = 3,
}) => (
  <div
    data-testid={testId}
    className={cn(
      'jg-search-grid jg-clearfix',
      {
        'jg-search-grid--1-col@sm': smCols === 1,
        'jg-search-grid--2-col@sm': smCols === 2,
      },
      'jg-search-grid--2-col@md',
      {
        'jg-search-grid--2-col@lg': lgCols === 2,
        'jg-search-grid--3-col@lg': lgCols === 3,
      }
    )}
  >
    {children}
  </div>
);
export default Grid;
